export default __webpack_public_path__ + "assets/icons/notify.c863436e.svg";